import React from "react";

import createBaseRenderer from "./createBaseRenderer";

import { Uzivatel, Zakaznik } from "./ciselnik";

export default createBaseRenderer({
  name: "zadavatel",
  placeholderText: "CD Informacni systemy",
  content: ({ val }) => (
    <>
      <Zakaznik val={val.zakaznik} />
      <Uzivatel val={val.uzivatel} />
    </>
  )
});
